import { render, staticRenderFns } from "./trecho.vue?vue&type=template&id=431cc668"
import script from "./trecho.vue?vue&type=script&lang=js"
export * from "./trecho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports